import {
    Collapse,
    // Dropdown,
    // Alert,
    // Button,
    // Carousel,
    Modal,
    // Offcanvas,
    // Popover,
    // ScrollSpy,
    // Tab,
    // Toast,
    // Tooltip,
} from 'bootstrap';

/* Custom SCSS */
// import "./index.scss";
// import './style-login.scss';
// import './style-admin.scss';
// import './style-buttons.scss';

/* Swiper */

import Swiper from "swiper/bundle";
import "swiper/css/bundle";
window.Swiper = Swiper;

// Swiper.use([Scrollbar]);
// init Swiper:

// import swiperSlider from "./js/swiperSlider";
// swiperSlider();

/* Fancybox */

// import { Fancybox } from "@fancyapps/ui";
// import "@fancyapps/ui/dist/fancybox.css";

/* Gsap */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

// var Isotope = require('isotope-layout');

import massimo from "./js/massimo";
massimo();

import navbar from "./js/navbar";
navbar();

import footer from "./js/footer";
footer();

import sidebar from "./js/sidebar";
sidebar();

import search from "./js/search";
search();

// import woocommerce from "./js/woocommerce";
// woocommerce();

import scrollTop from "./js/scrollTop";
scrollTop();

import sliderHero from "./js/blocks/sliderHero";
sliderHero();

import sliderCat from "./js/blocks/sliderCat";
sliderCat();

import counter from "./js/blocks/counter";
counter();

import blockSettori from "./js/blocks/blockSettori";
blockSettori();

import sliderNews from "./js/blocks/sliderNews";
sliderNews();

import sliderTestimonial from "./js/blocks/sliderTestimonial";
sliderTestimonial();

import blockListDownload from "./js/blocks/blockListDownload";
blockListDownload();

import sliderTimeline from "./js/blocks/sliderTimeline";
sliderTimeline();

import slider from "./js/blocks/slider";
slider();

import sliderTraguardi from "./js/blocks/sliderTraguardi";
sliderTraguardi();

import sliderText from "./js/blocks/sliderText";
sliderText();

import sliderProducts from "./js/blocks/sliderProducts";
sliderProducts();

import productTabs from "./js/productTabs";
productTabs();

import productFormati from "./js/productFormati";
productFormati();
